import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { ToastrService } from 'ngx-toastr';
import { DaoService } from '../../core/dao/dao.service';
import { IAudioPlugin } from '../../core/models/plugin.model';
import { TaskModel } from '../task/task.model';
import { faUser, faSignOut, faPlus, faCircleNotch, faRecycle } from '@fortawesome/free-solid-svg-icons';
import { AuthService } from '../../core/auth/auth.service';
import { IAcusticaSubscription } from '../../core/models/acustica-subscription.model';
import { IUser, User } from '../../core/models/acustica-user.model';
import { flatMap } from 'rxjs';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { environment } from '../../../environments/environment.prod';


@Component({
  selector: 'app-settings',
  templateUrl: 'settings.component.html',
  styleUrls: ['./settings.component.scss']
})
export class SettingsComponent implements OnInit {
  user: any = {};
  userData!: IUser;
  computingUnits!: number;
  faUser = faUser;
  faSignOut = faSignOut;
  faPlus = faPlus;
  faCircleNotch = faCircleNotch;
  faRecycle = faRecycle;
  isLoading: boolean = false;

  constructor(
    private dao: DaoService,
    private authService: AuthService,
    private toastr: ToastrService,
    private auth: OidcSecurityService,
    private loader: NgxUiLoaderService,
    public dialogRef: MatDialogRef<SettingsComponent>,
  ) {
  }

  ngOnInit() {
    this.getComputingUnits();
  }

  logout() {
    this.auth.logoff();
  }

  close() {
    this.dialogRef.close();
  }

  buyComputingUnits() {
    location.href = environment.shopLink;
  }

  getComputingUnits() {
    this.isLoading = true;
    // this.dao.SyncOrders()
    //   .pipe(
    //     flatMap(data => {
    //       return this.dao.SyncSlots();
    //     }))
    this.dao.SyncSlots()
      .subscribe(
        result => {
          this.auth.getUserData().subscribe(response => {
            this.user = response;
          })
          this.dao.GetUser().subscribe((response) => {
            this.userData = response;
            this.computingUnits = this.userData.computingUnits + this.userData.computingUnitsExtra;
          })
        },
        error => {
        }, () => {
          this.isLoading = false;
        })
  }

  setUserEmailNotifications() {
    this.userData.enableEmailNotifications = !this.userData.enableEmailNotifications;
    this.dao
      .SetUserEmailNotifications(this.userData.enableEmailNotifications)
      .subscribe();
  }
}
